import React from "react";

import * as S from "./styles";

export const Fluidos: React.FC = () => {
  return (
    <S.Container>
      <S.Content>
        <S.FirstSection>
          <S.Text className="black">
            <p>
              Também utilizando um tecido derivado dessa mesma matéria-prima, a
              jaqueta{" "}
              <a
                href="https://www.instagram.com/p/B7lzlvwAR-I/?hl=en"
                target="_blank"
                rel="noreferrer"
              >
                Moon Parka
              </a>
              , da North Face, foi lançada em parceria com outra companhia de
              experimentos biotecnológicos, a japonesa{" "}
              <a
                href="https://www.spiber.inc/en/"
                target="_blank"
                rel="noreferrer"
              >
                Spiber.
              </a>
            </p>
          </S.Text>
          <S.Photo1Wrapper>
            <S.CreditPhoto1>The North Face</S.CreditPhoto1>
            <S.Photo1 />
            <S.PhotoMobile1 />
          </S.Photo1Wrapper>
        </S.FirstSection>
        <S.Wrapper>
          <S.Title>
            Fluidos
            <br />
            corporais
          </S.Title>
          <S.TextWrapper>
            <S.Text>
              <p>
                Vestir cogumelos, cactos, abacaxis, algas marinhas e teias de
                aranha pode parecer ficção científica para muitos, mas a
                discussão pode ir ainda mais longe.{" "}
                <a
                  href="http://www.alicepotts.com/"
                  target="_blank"
                  rel="noreferrer"
                >
                  Alice Potts
                </a>
                , designer londrina apaixonada por estudar a relação entre
                biomateriais e o corpo humano, é a responsável por criar
                acessórios com base em nada mais, nada menos que o próprio suor
                do corpo humano.{" "}
              </p>

              <p>
                “Eu amo esportes! Eu vivo pelo suor!”, começa dizendo a designer
                em entrevista à ELLE Brasil. Alice percebeu que poderia explorar
                essa matéria-prima por meio das linhas brancas que o suor, uma
                vez que secava, deixava como rastro nas roupas de academia das
                pessoas.
              </p>
            </S.Text>
            <S.Text>
              <p>
                Tais linhas brancas eram formadas por minúsculos cristais de
                sal, que não evaporavam. “Então, se eu pudesse coletar grandes
                quantidades de suor e condensá-las em um cristal, qual seria o
                tamanho e como seria? Foi quando a coisa toda ficou fora de
                controle”, diz Alice ao ser questionada sobre o início de seus
                experimentos.
              </p>

              <p>
                A ideia se formou a partir de um background de estudos muito
                diverso. Ao relembrar sua trajetória, ela conta que sua grande
                paixão é a matemática, mas que a perspectiva de uma carreira sem
                explorações criativas a assustava. Foi somente no seu mestrado
                que conseguiu unir suas grandes paixões – exercícios físicos,
                matemática e moda – e desenvolver projetos por meio da
                biotecnologia.
              </p>
            </S.Text>
          </S.TextWrapper>
        </S.Wrapper>
      </S.Content>
    </S.Container>
  );
};
